import {
  ADD_RECORD,
  DELETE_RECORD,
  SELECT_RECORD,
  UPDATE_RECORD,
  CLEAR_ALL_RECORDS,
  INIT_SELECT_RECORD,
  RESET_STORE,
  ADD_SINGLE_RECORD,
  ADD_ARRAY
} from "./actionTypes";

import { uiStartLoading, setUiFlag } from "./index";
import { uiStopLoading } from "./ui";
//import { logger } from "../../app/utils/utils.js";
import moment from "moment";
import "regenerator-runtime/runtime";

import dbGetRecords from "../../Services/Firebase/Generic/dbGetRecords";
import getFbRtData from "../../Services/Firebase/Generic/getFbRtData";
import dbAddRecord from "../../Services/Firebase/Generic/dbAddRecord";
import dbUpdateRecord from "../../Services/Firebase/Generic/dbUpdateRecord";
import dbDeleteRecord from "../../Services/Firebase/Generic/dbDeleteRecord";
import dbGetStatement from "../../Services/statements/dbGetStatement";
import dbGetStatementB64 from "../../Services/statements/dbGetStatementB64";
import dbGetAutoId from "../../Services/Firebase/Generic/dbGetAutoId";
import { useLocal } from "../../staticData/rawState";
import { sendNotificationToASegment } from "../../Services/OneSignal/sendNotificationToASegment";
import { sendSingleUserANotification } from "../../Services/OneSignal/sendSingleUserANotification";
import configureStore from "../configureStore";

import "regenerator-runtime/runtime";
import getDistance from "../../Services/Firebase/Generic/getDistance";

/*========================================================================
passport scan operations
==========================================================================*/

//GET PHOTO TEXT
export function reachApi(objContents) {
  //console.log('fbRegisterUser: ' + userId + ' ' + password);
  //alert(JSON.stringify(objContents));
  return async dispatch => {
    function onSuccess(success) {
      //console.log("darn it now...");
      return success;
    }
    function onError(error) {
      return error;
    }

    dispatch(setUiFlag("mainLoadMessage", "Processing ID..."));
    var headers = objContents.headers;
    var message = objContents.message;
    //alert(JSON.stringify(arrExternalUserIds));
    let fetchQuery = objContents.fetchQuery;
    await fetch(fetchQuery, {
      method: objContents.method,
      body: message,
      headers: headers
    })
      .then(res => res.json())
      .then(parsedRes => {
        //alert(JSON.stringify(parsedRes));
        dispatch(
          actionAddSingleRecord({
            path: objContents.path,
            payload: parsedRes
          })
        );
        dispatch(setUiFlag("idScanInProgress", false));
        return onSuccess(parsedRes);
      })
      .catch(err => {
        alert(
          "We are unable to complete your request at this time, please check your network connection or contact support. " +
            err
        );
        return onError(err);
        ////console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
      });
  };
}

//GET PHOTO TEXT
export function reachApiExtended(objContents) {
  return dispatch => {
    var headers = objContents.headers;
    var message = objContents.message;
    let fetchQuery = objContents.fetchQuery;
    fetch(fetchQuery, {
      method: objContents.method,
      body: message,
      headers: headers
    })
      .then(res => res.json())
      .then(parsedRes => {
        dispatch(
          actionAddSingleRecord({
            path: objContents.path,
            payload: parsedRes
          })
        );
        return "";
      })
      .catch(err => {
        return err;
        ////console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
      });
  };
}
/*========================================================================
google maps operations
==========================================================================*/

//GET DISTANCE
export function fetchDistance(origin, destination) {
  return async dispatch => {
    function onSuccess(success) {
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      dispatch(getDistance(origin, destination)).then(returnData => {
        if (returnData && returnData !== undefined) {
          //logger("DEBUG", "fetchRecords(" + data.path + ")", "Adding :" + JSON.stringify(returnData.length + " items"));
          dispatch(
            actionAddSingleRecord({ path: "distance", payload: returnData })
          );

          return onSuccess(returnData);
        }
      });
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

/*========================================================================
photo operations
==========================================================================*/

//UPLOAD PHOTO
export function uploadPhoto(
  firebase,
  imageName,
  imagePath,
  photoBlob,
  dbKey,
  cloudPath
) {
  return async dispatch => {
    function onSuccess(success) {
      console.log("success from upload: " + success);
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      let bucketRef = firebase.storage
        .ref(imagePath + "/" + imageName)
        .put(photoBlob);

      bucketRef.on(
        "state_changed",
        snapshot => {
          //progress
        },
        error => {
          console.log(error);
        },
        () => {
          //completed
          firebase.storage
            .ref(imagePath)
            .child(imageName)
            .getDownloadURL()
            .then(url => {
              //save url to db here

              firebase.db
                .ref("/" + cloudPath + "/" + dbKey)
                .once("value")
                .then(snap => {
                  let resRef = snap.val();
                  let res = _.cloneDeep(resRef);
                  let tgtImage = res.photos.find(
                    item => item.imageName === imageName
                  );
                  if (tgtImage && tgtImage !== undefined) {
                    tgtImage.url = url;
                    tgtImage.status = "DONE";
                  }

                  return snap.ref.set(res);
                })
                .catch(err => {
                  console.log(err);
                  console.log("some error: " + err);
                })
                .then(err => {});
            });
        }
      );

      return onSuccess("some url");
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

export function deletePhoto(firebase, imageName, imagePath, dbKey, cloudPath) {
  return async dispatch => {
    function onSuccess(success) {
      console.log("success from upload: " + success);
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      //console.log(imageName);
      let bucketRef = firebase.storage.ref().child(imagePath + "/" + imageName);

      bucketRef
        .delete()
        .then(function() {
          if (dbKey && dbKey !== null && cloudPath && cloudPath !== null) {
            firebase.db
              .ref("/" + cloudPath + "/" + dbKey)
              .once("value")
              .then(snap => {
                let resRef = snap.val();
                let res = _.cloneDeep(resRef);
                let newArray = res.photos.filter(
                  item => item.imageName !== imageName
                );

                res.photos = newArray;

                return snap.ref.set(res);
              })
              .catch(err => {
                console.log(err);
                console.log("some error: " + err);
              })
              .then(err => {});
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      return onSuccess("some url");
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

/*========================================================================
accounting operations
==========================================================================*/

//GEN AUTO ID
export function getAcctStatement(reqParams) {
  /*

  receives:
  {
    accIdArry:[{accName: 'xxx'}]
    fromDate: DD-MM-YYYY,
    toDate: DD-MM-YYYY,
  }

  */
  return async dispatch => {
    function onSuccess(success) {
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      let db = configureStore.getState().db;
      let success = {};

      let finalResults = [];
      if (db && db.accounts && db.accounts.length > 0) {
        for (let i = 0; i < reqParams.accIdArray.length; i++) {
          let accName = reqParams.accIdArray[i].accName;
          let acctEntries = await getStmtEntry(accName, db, reqParams);
          finalResults = finalResults.concat(acctEntries);
        }
        success = finalResults;
      }
      return onSuccess(success);
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

const getStmtEntry = async (accName, db, reqParams) => {
  //iterate through rules
  //collect entries
  //combine and sort
  let tgtAccount = db.accounts.find(item => item.accountName === accName);
  if (tgtAccount && tgtAccount !== undefined) {
    let allEntries = [];
    let rules = tgtAccount.accountingRules;
    for (let j = 0; j < rules.length; j++) {
      let singleRule = rules[j];
      let ruleResults = await getEntriesForRule(
        accName,
        db,
        singleRule,
        reqParams
      );
      //console.log("rulesResult: " + JSON.stringify(ruleResults));
      allEntries = allEntries.concat(ruleResults);
    }
    if (allEntries.length > 0) {
      allEntries = _.chain(allEntries)
        .sortBy("jsDate")
        .reverse()
        .value();
    }
    //console.log("allEntries: " + JSON.stringify(allEntries));
    return allEntries;
  } else {
    return [];
  }
};

const getEntriesForRule = async (accName, db, singleRule, reqParams) => {
  //table
  //direction
  //amount field
  //match field
  //start date
  //end date
  let finalResult = [];
  let tgtTable = db[singleRule.targetTable];
  let accEntries = tgtTable.filter(tgtRec => {
    let filterResult = true;
    //check for match field
    if (
      singleRule.matchField &&
      tgtRec[singleRule.matchField] &&
      tgtRec[singleRule.matchField] !== accName
    ) {
      filterResult = false;
    }
    //check date
    let recDate = tgtRec[singleRule.acctDateField];
    let momRecDate = moment(recDate, "DD-MM-YYYY");
    let momStDate = moment(reqParams.fromDate, "DD-MM-YYYY");
    let momEndDate = moment(reqParams.endDate, "DD-MM-YYYY");
    if (!momRecDate.isBetween(momStDate, momEndDate, "[]", "minute")) {
      filterResult = false;
    }
    return filterResult;
  });
  if (accEntries && accEntries.length > 0) {
    finalResult = accEntries.map(item => {
      return {
        side: singleRule.accSide,
        amount: item[singleRule.amountField],
        date: item[singleRule.acctDateField],
        description: item[singleRule.referenceField],
        jsDate: moment(item[singleRule.acctDateField], "DD-MM-YYYY")
      };
    });
    return finalResult;
  } else {
    return [];
  }
};

//GEN AUTO ID
export function getAcctBalance(reqParams) {
  /*

  receives:
  {
    accIdArry:[{accName: 'xxx'}]
    fromDate: DD-MM-YYYY,
    toDate: DD-MM-YYYY,
  }

  */
  return async dispatch => {
    function onSuccess(success) {
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      let db = configureStore.getState().db;
      let success = {};

      let tmpArray = [];
      if (db && db.accounts && db.accounts.length > 0) {
        for (let i = 0; i < reqParams.accIdArray.length; i++) {
          let accName = reqParams.accIdArray[i].accName;
          let acctEntries = await getStmtEntry(accName, db, reqParams);

          tmpArray = _.chain(acctEntries)
            .groupBy("date")
            .map(function(value, key) {
              return {
                date: key,
                jsDate: moment(key, "DD-MM-YYYY"),
                debit: _.chain(value)
                  .filter(item => item.side === "DEBIT")
                  .reduce((sum, curr, index) => {
                    let amt = parseFloat(curr.amount);
                    sum = sum + amt;
                    if (sum > 0) {
                      sum = parseFloat(sum.toFixed(2));
                    }
                    return sum;
                  }, 0)
                  .value(),
                credit: _.chain(value)
                  .filter(item => item.side === "CREDIT")
                  .reduce((sum, curr, index) => {
                    let amt = parseFloat(curr.amount);
                    sum = sum + amt;
                    if (sum > 0) {
                      sum = parseFloat(sum.toFixed(2));
                    }
                    return sum;
                  }, 0)
                  .value()
              };
            })
            .map(item => {
              return {
                ...item,
                netDebit:
                  item.debit > item.credit
                    ? parseFloat((item.debit - item.credit).toFixed(2))
                    : 0,
                netCredit:
                  item.credit > item.debit
                    ? parseFloat((item.credit - item.debit).toFixed(2))
                    : 0
              };
            })
            .reverse()
            .value();

          for (let i = 0; i < tmpArray.length; i++) {
            if (i === 0) {
              tmpArray[i].closingDebitBalance = tmpArray[i].netDebit;
              tmpArray[i].closingCreditBalance = tmpArray[i].netCredit;
            } else {
              let currIndex = i;
              let prevIndex = i - 1;
              let currNetDebit = tmpArray[currIndex].netDebit;
              let currNetCredit = tmpArray[currIndex].netCredit;
              let prevClosingDebit = tmpArray[prevIndex].closingDebitBalance;
              let prevClosingCredit = tmpArray[prevIndex].closingCreditBalance;
              let runningDebit = currNetDebit + prevClosingDebit;
              let runningCredit = currNetCredit + prevClosingCredit;
              tmpArray[i].closingDebitBalance =
                runningDebit > runningCredit
                  ? parseFloat((runningDebit - runningCredit).toFixed(2))
                  : 0;
              tmpArray[i].closingCreditBalance =
                runningCredit > runningDebit
                  ? parseFloat((runningCredit - runningDebit).toFixed(2))
                  : 0;
            }
          }
        }
        success = tmpArray.reverse();
      }
      return onSuccess(success);
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

/*========================================================================
Firebase related complex operations, multiple updates
==========================================================================*/

export function loadAllStats(parsedRes) {
  return dispatch => {};
}

export function notifyUsers(msgBody, arrayOfUserIds, sendToAll) {
  return async dispatch => {
    function onSuccess(success) {
      //console.log(tableName + ": Total Records: " + success.length);
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      if (true) {
        if (sendToAll) {
          //console.log("sending to segment skipped");
          sendNotificationToASegment({ en: msgBody }, ["Subscribed Users"]);
        } else {
          //console.log("sending to users: " + JSON.stringify(arrayOfUserIds));
          sendSingleUserANotification({ en: msgBody }, arrayOfUserIds);
        }
      }
      return onSuccess(true);
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

//READ ALL RECORDS FROM A TARGET TABLE
export function fetchRecords(
  isNotPull,
  data,
  idToken,
  criteria,
  isCustomPath,
  fieldsArray
) {
  //logger("DEBUG", "fetchRecords(" + data.path + ")", ">>Criteria :" + JSON.stringify(criteria)+" isCustomPath: "+isCustomPath);
  //console.log('getHours received: '+isCustomPath);
  if (isCustomPath === undefined || isCustomPath === "") {
    //console.log(data.path+' setting customPath to false, when recvd val was: '+isCustomPath);
    isCustomPath = false;
  }
  return dispatch => {
    //console.log("fetchRecords: got token from authGetToken ");
    if (isNotPull) {
      //console.log("starting loader");
      dispatch(uiStartLoading());
    } else {
      //console.log("It's a pull refresh");
    }
    dispatch(clearAllExistingRecords(data));
    dispatch(
      dbGetRecords(data.path, idToken, criteria, isCustomPath, fieldsArray)
    )
      .then(returnData => {
        if (returnData && returnData !== undefined) {
          //logger("DEBUG", "fetchRecords(" + data.path + ")", "Adding :" + JSON.stringify(returnData.length + " items"));
          dispatch(
            actionAddArray2Redux({ path: data.path, payload: returnData })
          );

          dispatch(uiStopLoading());
          //logger("DEBUG", "fetchRecords(" + data.path + ")", "Successful fetch: " + data.path);
          return returnData;
        }
      })
      .catch(err => {
        //logger("BASIC", "fetchRecords(" + data.path + ")", "Some error fetching data" + err);
        alert(
          "Not able to completed your request. Please check network connection and try again. " +
            err +
            " REQU: " +
            JSON.stringify(data)
        );
        dispatch(uiStopLoading);
      });
  };
}

export function initialProductsFetch(url, accessToken) {
  return dispatch => {
    //console.log(url);
    //console.log(moment().format("x") + " db initial loading s1 " + tableName);

    dispatch(getFbRtData(url, accessToken))
      .then(returnData => {
        if (returnData && returnData !== undefined) {
          let tmpArray = Object.keys(returnData).map(key => ({
            ...returnData[key],
            key: key
          }));
          tmpArray = tmpArray.reverse();
          console.log(JSON.stringify(tmpArray));
          dispatch(
            actionAddArray2Redux({
              path: "supplierShopItems",
              payload: tmpArray
            })
          );
          let groupedProds = _.chain(tmpArray)
            .groupBy("category")
            .value();
          Object.keys(groupedProds).map(key => {
            if (key !== "POPULAR" && key !== undefined) {
              dispatch(
                actionAddArray2Redux({ path: key, payload: groupedProds[key] })
              );
            }
          });

          return "";
        } else {
          console.log("db initial loading s1 " + tableName + " loaded nothing");
        }
      })
      .catch(err => {
        console.log("db initial loading s1 " + tableName + " " + err);
      });
  };
}

export function initialFetch(tableName, url, accessToken) {
  return dispatch => {
    //console.log(url);
    //console.log(moment().format("x") + " db initial loading s1 " + tableName);

    dispatch(getFbRtData(url, accessToken))
      .then(returnData => {
        if (returnData && returnData !== undefined) {
          //logger("DEBUG", "fetchRecords(" + data.path + ")", "Adding :" + JSON.stringify(returnData.length + " items"));
          // console.log(
          //   moment().format("x") +
          //     " db initial loading s1 " +
          //     tableName +
          //     " rcvd data"
          // );
          let tmpArray = Object.keys(returnData).map(key => ({
            ...returnData[key],
            key: key
          }));
          tmpArray = tmpArray.reverse();

          dispatch(
            actionAddArray2Redux({ path: tableName, payload: tmpArray })
          );

          return "";
        } else {
          console.log("db initial loading s1 " + tableName + " loaded nothing");
        }
      })
      .catch(err => {
        console.log("db initial loading s1 " + tableName + " " + err);
      });
  };
}

export function loadFbData(tableName, firebase, onceOnly, subPath, singleObj) {
  return async dispatch => {
    function onSuccess(success) {
      // console.log(tableName + ": Total Records: " + success.length);

      return success;
    }
    function onError(error) {
      return error;
    }
    let tgtFbTable = tableName;
    if (subPath) {
      tgtFbTable = subPath;
    }
    try {
      //console.log("loadFbData " + tableName);
      //console.log(moment().format("x") + " db loading s1 " + tableName);
      if (onceOnly) {
        let tmpArray = [];
        let fbOject = [];
        let revArray = await firebase.db
          .ref("/" + tgtFbTable)
          .once("value", snapshot => {
            if (snapshot && snapshot !== undefined) {
              let res = snapshot.val();
              // console.log(
              //   moment().format("x") +
              //     " db snapshotting s1 " +
              //     tableName +
              //     " res received"
              // );

              if (res && res !== undefined) {
                tmpArray = Object.keys(res).map(key => ({
                  ...res[key],
                  key: key
                }));
                // console.log(
                //   moment().format("x") +
                //     " db keys " +
                //     tableName +
                //     " keys processed"
                // );
                revArray = tmpArray.reverse();
                // console.log("dispatching results now");
                // console.log(
                //   moment().format("x") +
                //     " db reversing " +
                //     tableName +
                //     " reversing done"
                // );
                if (singleObj) {
                  dispatch(
                    actionAddSingleRecord({
                      path: tableName,
                      payload: res
                    })
                  );
                } else {
                  dispatch(
                    actionAddArray2Redux({
                      path: tableName,
                      payload: revArray
                    })
                  );
                }
                return revArray;
              } else {
                // console.log("no data with async for " + tableName);
              }
            }
          });
        return onSuccess(revArray);
      } else {
        let tmpArray = [];
        let fbOject = [];
        dispatch(setUiFlag(tableName + "-downloaded", false));
        let finRes = await firebase.db
          .ref("/" + tgtFbTable)
          .on("value", snapshot => {
            if (snapshot && snapshot !== undefined) {
              let res = snapshot.val();
              // console.log(
              //   moment().format("x") +
              //     " db snapshotting s1 " +
              //     tableName +
              //     " res received"
              // );
              if (res && res !== undefined) {
                tmpArray = Object.keys(res).map(key => ({
                  ...res[key],
                  key: key
                }));
                // console.log(
                //   moment().format("x") +
                //     " db keys " +
                //     tableName +
                //     " keys processed"
                // );
                let revArray = tmpArray.reverse();
                // console.log(
                //   moment().format("x") +
                //     " db snapshotting " +
                //     tableName +
                //     " res received"
                // );
                //console.log("dispatching results now");
                if (singleObj) {
                  dispatch(
                    actionAddSingleRecord({
                      path: tableName,
                      payload: res
                    })
                  );
                } else {
                  dispatch(
                    actionAddArray2Redux({
                      path: tableName,
                      payload: revArray
                    })
                  );
                }
                dispatch(setUiFlag(tableName + "-downloaded", true));
              } else {
                dispatch(setUiFlag(tableName + "-downloaded", true));
                console.log("no data with async for " + tableName);
              }
            }
          });
        return onSuccess([]);
      }
    } catch (error) {
      console.log("Some error: " + error);
      dispatch(setUiFlag(tableName + "-downloaded", true));
      return onError(error);
    }
  };
}

//setup users and admin status:
export function setupUsers(currEmail, firebase, teamName, fbCloudUrl, fbDbUrl) {
  return async dispatch => {
    function onSuccess(success) {
      // console.log("rcvd this into success: " + JSON.stringify(success));
      // dispatch(
      //   actionAddSingleRecord({
      //     path: parsedRes.tableName,
      //     payload: success
      //   })
      // );
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      firebase.db.ref("/users").on("value", snapshot => {
        console.log("Linking users");
        let tmpArray = [];
        let fbOject = [];
        Promise.all([snapshot.val()]).then(res => {
          fbOject = res[0];
          //console.log("now recieved the response for teams loading");
          tmpArray = Object.keys(fbOject).map(key => ({
            ...fbOject[key],
            key: key
          }));
          tmpArray.reverse();
          //console.log("array reversed");
          ////console.log("Total Records: " + tmpArray.length);
          dispatch(actionAddArray2Redux({ path: "users", payload: tmpArray }));

          let currentUser = {};

          //

          currentUser = tmpArray.find(userObj => {
            if (userObj.userEmail === currEmail) {
              return userObj;
            }
          });

          //console.log("admin status: " + JSON.stringify(currentUser));

          dispatch(
            actionAddSingleRecord({
              path: "userProfile",
              payload: currentUser
            })
          );

          if (currentUser !== undefined) {
            console.log("~!@~!@ " + JSON.stringify(currentUser));
            let isThisAdmin =
              currentUser.roleName === "ADMIN" ||
              currentUser.roleName === "SUPERADMIN";
            let isThisSuperAdmin = currentUser.roleName === "SUPERADMIN";
            dispatch(setUiFlag("currUserRole", currentUser.roleName));
            dispatch(setUiFlag("isThisAdmin", isThisAdmin));
            dispatch(setUiFlag("isThisSuperAdmin", isThisSuperAdmin));

            dispatch(
              actionAddSingleRecord({
                path: "currentUser",
                payload: currentUser
              })
            );

            dispatch(
              actionAddSingleRecord({
                path: "team",
                payload: {
                  name: teamName,
                  fbCloudUrl: fbCloudUrl,
                  fbDbUrl: fbDbUrl
                }
              })
            );
            return onSuccess("success");
          }
        });
      });
    } catch (error) {
      console.log("Some error: " + error);
      return onError(error);
    }
  };
}

//GEN AUTO ID
export function getId(parsedRes) {
  return async dispatch => {
    function onSuccess(success) {
      console.log("rcvd this into success: " + JSON.stringify(success));
      dispatch(
        actionAddSingleRecord({
          path: parsedRes.tableName,
          payload: success
        })
      );
      return success;
    }
    function onError(error) {
      return error;
    }
    try {
      const success = await dispatch(
        dbGetAutoId(parsedRes.idPrefix, parsedRes.idToken)
      );
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

//GET PO STATEMENT
export function getStatement(templateId, jsonData) {
  return async dispatch => {
    function onSuccess(success) {
      //console.log("rcvd this into success: " + JSON.stringify(success));
      return success;
    }
    function onError(error) {
      console.log("rcvd this into error: " + JSON.stringify(error));
      return error;
    }
    try {
      const success = await dispatch(dbGetStatement(templateId, jsonData));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

//GET PO STATEMENT B64
export function getStatementB64(templateId, jsonData, mailParams) {
  return async dispatch => {
    function onSuccess(success) {
      //console.log("rcvd this into success: " + JSON.stringify(success));
      return success;
    }
    function onError(error) {
      console.log("rcvd this into error: " + JSON.stringify(error));
      return error;
    }
    try {
      const success = await dispatch(
        dbGetStatementB64(templateId, jsonData, mailParams)
      );
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

//READ ALL STATS FROM A TARGET TABLE
export function fetchStats(queryObj, idToken) {
  console.log(
    "fetchStats(" + queryObj.path + ")",
    "queryObj :" + JSON.stringify(queryObj)
  );
  return async dispatch => {
    //console.log("fetchStats: got token from authGetToken ");
    let data = { path: queryObj.path };

    dispatch(clearAllExistingRecords(data));
    dispatch(localGetStats(queryObj))
      .then(returnData => {
        console.log(
          "========>fetchStats(" +
            queryObj.path +
            "). Completed: " +
            JSON.stringify(returnData)
        );
        dispatch(
          actionAddArray2Redux({
            path: queryObj.path,
            payload: returnData
          })
        );
        dispatch(uiStopLoading());
      })
      .catch(err => {
        console.log("Some error ====>");
      });
  };
}

//ADD PROJECT TO FIREBASE DATABASE AND THEN ADD TO REDUX
export function addRecord(data, idToken, multi) {
  return dispatch => {
    uiStartLoading();

    dispatch(authGetToken()).then(token => {
      dispatch(dbAddRecord(data, token))
        .then(resKey => {
          let dataBundle = {
            ...data,
            key: resKey
          };
          dispatch(actionAddRecord2Redux(dataBundle));
          /*console.log(
                "Creating notification now: here is data: " +
                  JSON.stringify(data)
              );*/
          if (
            data.path === "notices" ||
            data.path === "logistics" ||
            data.path === "tasks"
          ) {
            //console.log("notification conditin is met");
            //alert(data.notificationText);
            sendNotificationToASegment({ en: data.notificationText }, [
              "Active Users"
            ]);
          }
          dispatch(
            selectARecord({
              key: dataBundle.key,
              path: dataBundle.path
            })
          );
          uiStopLoading();
          if (multi === "yes") {
            alert("Record Added");
          }
        })
        .catch(err => {
          //logger("DEBUG", "addRecord(data)", "Caught exception " + err);
          alert(
            "Not able to completed your request. Please check network connection and try again. " +
              err
          );
          dispatch(uiStopLoading());
        });
    });
  };
}

//UPDATE AN EXISTING PROJECT TO FIREBASE DATABASE AND ALSO UPDATE INTO REDUX STATE
export function updateRecord(data) {
  //logger("DEBUG", "updateRecord(data)", "-------Updating record to DB " + JSON.stringify(data));
  return dispatch => {
    dispatch(dbUpdateRecord(data, token))
      .then(resKey => {
        //logger("DEBUG", "--updateRecord(data)", "Updating record to redux " + JSON.stringify(data));
        dispatch(actionUpdateRecord2Redux(data));
        if (
          data.path === "notices" ||
          data.path === "logistics" ||
          data.path === "tasks"
        ) {
          //console.log("notification conditin is met");
          //alert(data.notificationText);
          if (data.notificationText !== "") {
            sendNotificationToASegment({ en: data.notificationText }, [
              "Active Users"
            ]);
          }
        }
        dispatch(uiStopLoading());
      })
      .catch(err => {
        //logger("DEBUG", "updateRecord(data)", "!!!--Caught exception " + err);
        alert(
          "Not able to completed your request. Please check network connection and try again. " +
            err
        );
        dispatch(uiStopLoading());
      });
  };
}

export function deleteRecord(data) {
  //logger("DEBUG", "deleteARecord(data)", "-------Deleting record from DB " + JSON.stringify(data));
  return dispatch => {
    if (useLocal) {
      dispatch(uiStartLoading());
      //logger("DEBUG", "deleteARecord(data)", "Deleting record from redux " + JSON.stringify(data));
      dispatch(actionDeleteARecord(data));
      dispatch(uiStopLoading());
    } else {
      dispatch(uiStartLoading());
      dispatch(authGetToken())
        .then(token => {
          dispatch(dbDeleteRecord(data, token))
            .then(resKey => {
              //logger("DEBUG", "deleteARecord(data)", "Deleting record from redux " + JSON.stringify(data));
              dispatch(actionDeleteARecord(data));
              dispatch(uiStopLoading());
            })
            .catch(err => {
              //logger("DEBUG", "deleteARecord(data)", "!!!--Caught exception " + err);
              alert(
                "We are unable to complete your request at this time, please check your network connection or contact support"
              );
              dispatch(uiStopLoading());
            });
        })
        .catch(err => {
          //logger("DEBUG", "deleteARecord(data)", "!!!--Caught exception " + err);
          alert(
            "We are unable to complete your request at this time, please check your network connection or contact support"
          );
          dispatch(uiStopLoading());
        });
    }
  };
}

function getMsSinceMidnight(d) {
  let e = new Date(d);
  return "-KXX" + (d - e.setHours(0, 0, 0, 0));
}

/*========================================================================
All things Redux, updates to redux state
==========================================================================*/
//ADD A NEW RECORD TO REDUX, THIS IS DONE AFTER FIREBASE HAS BEEN DONE
export const actionAddRecord2Redux = data => {
  //logger("FULL", "actionAddRecord2Redux", "Adding record to Redux " + JSON.stringify(data));
  return {
    type: ADD_RECORD,
    ...data
  };
};

//USED FOR REFRESHING FULL LIST/TABLE TO REDUX, THIS IS DONE AFTER FIREBASE HAS BEEN DONE
export const actionAddArray2Redux = data => {
  //logger("FULL", "actionAddRecord2Redux", "Adding record to Redux " + JSON.stringify(data));
  return {
    type: ADD_ARRAY,
    ...data
  };
};

//SELECT A RECORD FOR EDITING OR VIEWING
export function selectARecord(data) {
  //logger("DEBUG", "selectARecord(data)", "Selecting a record " + JSON.stringify(data));
  return {
    type: SELECT_RECORD,
    ...data
  };
}

//SELECT A RECORD FOR EDITING OR VIEWING
export function actionAddSingleRecord(data) {
  // console.log(
  //   "into action in db actionAddSingleRecord: Rcvd this: " +
  //     JSON.stringify(data)
  // );
  return {
    type: ADD_SINGLE_RECORD,
    ...data
  };
}

//CLEAR SELECTED RECORD TO RE-INIT FOR NEW RECORDS
export function initSelectedRecord(data) {
  //logger("DEBUG", "initSelectedRecord(data)", "Selecting a record " + JSON.stringify(data));
  return {
    type: INIT_SELECT_RECORD,
    ...data
  };
}

//ADD A NEW RECORD TO REDUX, THIS IS DONE AFTER FIREBASE HAS BEEN DONE
export const actionUpdateRecord2Redux = data => {
  //logger("DEBUG", "actionUpdateRecord2Redux", "Updating a record in redux " + JSON.stringify(data));
  return {
    type: UPDATE_RECORD,
    ...data
  };
};

//CLEAR ALL EXISTING RECORDS FROM AN ARRAY
export const clearAllExistingRecords = data => {
  //logger("DEBUG", "clearAllExistingRecords", "Clearing all records for " + data.path);
  return {
    type: CLEAR_ALL_RECORDS,
    path: data.path
  };
};

//DELETE RECORD FROM DB AND FIREBASE
export const actionDeleteARecord = data => {
  //logger("DEBUG", "deleteARecord", "Deleting record for:  " + data.path + ": " + data.payload.key);
  return {
    type: DELETE_RECORD,
    ...data
  };
};

//RESET FIREBASE ON LOGOUT
export const resetRedux = () => {
  return {
    type: RESET_STORE
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/db.js